import React, { useState } from "react";
import { MdEmail } from "react-icons/md";
import auth from "../assets/Authentication.png";
import bgImage from "../assets/toys-bg.png";
import { useNavigate } from "react-router-dom";
import { useForgetPassword } from "../../context/ForgetPasswordContext";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { forgotPassword } = useForgetPassword();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // setLoading(true);
    setError(null);

    const response = await forgotPassword(email);
    setLoading(false);

    if (response.status === 200) {
      navigate("/verify"); // move to OTP verification page
    } else {
      setError(response.message || "Something went wrong. Please try again.");
    }
  };

  return (
    <section
      className="min-h-screen flex justify-center md:justify-end items-center bg-cover bg-center"
      style={{ backgroundImage: `url("https://cdn.acsdev.in/Rentastic/toysb.png")` }}
    >
      <div className="w-full max-w-md sm:max-w-sm md:max-w-md lg:max-w-lg bg-white/90 backdrop-blur-sm rounded-2xl shadow-md p-6 sm:p-8 md:p-10 mx-4 md:mr-16 lg:mr-32">
        {/* Logo & Heading */}
        <div className="flex flex-col items-center">
          <div className="w-24 h-24 rounded-full flex items-center justify-center mb-3">
            <img src={auth} alt="logo" className="w-24 h-24 object-contain" />
          </div>
          <h2 className="text-xl font-bold text-gray-900 mt-2">Forgot Password?</h2>
          <p className="text-sm text-gray-500 mt-1 text-center px-4">
            Enter the email address associated with your account and we'll send you a link to reset your password.
          </p>
        </div>

        {/* Form */}
        <form className="mt-6 space-y-6" onSubmit={handleSubmit}>
          <div className="flex items-center border-b-2 border-gray-200 focus-within:border-green-500 transition-all">
            <MdEmail className="text-green-500 text-xl mr-2" />
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full py-2 outline-none text-gray-700 bg-transparent placeholder-gray-400"
              required
            />
          </div>

          {error && <p className="text-red-500 text-sm">{error}</p>}

          <button
            type="submit"
            className={`w-full bg-green-500 text-white font-semibold py-2 rounded-full shadow transition-colors duration-300 ${
              loading ? "opacity-70 cursor-not-allowed" : "hover:bg-green-600"
            }`}
            disabled={loading}
          >
            {loading ? "Sending..." : "Submit"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default ForgotPassword;
